export const DISALLOWED_REJECT_JOB = 'disallowed';
export const ALLOWED_REJECT_JOB = 'allowed';
export const ALLOW_REASSIGN_REJECT_JOB = 'allowReassign';
export const DISPATCH_JOB_TEAM_VISIBILITY_ALL = "all";
export const DISPATCH_JOB_TEAM_VISIBILITY_MATCHING_OR_UNSET = "matching_or_unset";
export const DISPATCH_JOB_TEAM_VISIBILITY_MATCHING_ONLY = "matching_only";

export type DispatchJobTeamVisibility =
    | typeof DISPATCH_JOB_TEAM_VISIBILITY_ALL
    | typeof DISPATCH_JOB_TEAM_VISIBILITY_MATCHING_OR_UNSET
    | typeof DISPATCH_JOB_TEAM_VISIBILITY_MATCHING_ONLY;

export enum CHECK_IN_DELAY_MINUTES {
    zero = '0',
    one = '1',
    five = '5',
    ten = '10',
}

export enum CHECK_IN_RADIUS {
    short = '100',
    big = '300',
}

export enum DELETE_DAYS {
    never = '0',
    oneDay = '1',
    oneMonth = '30',
    threeMonths = '90',
}
